export default __webpack_public_path__ + "static/media/bg_result_lose.d395ab45.png";